import { render, staticRenderFns } from "./ToastsContainer.vue?vue&type=template&id=c4485c28&scoped=true&"
import script from "./ToastsContainer.vue?vue&type=script&lang=ts&"
export * from "./ToastsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ToastsContainer.vue?vue&type=style&index=0&id=c4485c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4485c28",
  null
  
)

export default component.exports